export default function <T, K extends keyof T>(data: Array<T>, sortingProperty: K) {
  return [...data].sort((a, b) => (a[sortingProperty] > b[sortingProperty] ? 1 : -1))
}
